import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "template-content" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "img-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "img-container" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "img-container" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]

import { ref } from 'vue'

import imgBpmGame from '@/assets/images/iphone 16 bpm game.png'
import imgSmartwatch from '@/assets/images/iphone 16 smartwatch connect.png'
import imgGuessGame from '@/assets/images/iphone 16 bpm guess game.png'

export default /*@__PURE__*/_defineComponent({
  __name: 'OurAppView',
  setup(__props) {

const modalImage = ref<string | null>(null)

function openModal(imageSrc: string) {
  modalImage.value = imageSrc
}

function closeModal() {
  modalImage.value = null
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("section", null, [
        _createElementVNode("h1", { class: "title" }, "Over onze app"),
        _createElementVNode("p", { class: "description" }, [
          _createTextVNode(" Samen met ons team hebben we een interactieve app ontwikkeld voor de Hartstichting, speciaal voor evenementen. De app laat gebruikers op een leuke manier hun hartslag ervaren door muziek en spelletjes. Zo zien ze welk muzieknummer bij hun hartslag past en kunnen ze hun hartslag raden in een spel."),
          _createElementVNode("br"),
          _createTextVNode(),
          _createElementVNode("br"),
          _createTextVNode(" Daarnaast is er een groepsspel waarbij deelnemers samen een gezamenlijke target hartslag proberen te halen, wat samenwerking en bewustzijn over hartgezondheid stimuleert. De app maakt hartslag meten speels, sociaal en inzichtelijk. ")
        ])
      ], -1)),
      _cache[7] || (_cache[7] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("section", null, [
        _createElementVNode("article", _hoisted_3, [
          _createElementVNode("img", {
            src: _unref(imgBpmGame),
            alt: "screenshot",
            class: "thumbnail",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal(_unref(imgBpmGame))))
          }, null, 8, _hoisted_4),
          _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "title" }, "Verbind je hartslag met muziek en zie welk nummer bij jouw past", -1))
        ])
      ]),
      _createElementVNode("section", null, [
        _createElementVNode("article", _hoisted_5, [
          _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "title" }, "Eenvoud en fairness staat centraal", -1)),
          _createElementVNode("img", {
            src: _unref(imgSmartwatch),
            alt: "screenshot",
            class: "thumbnail",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openModal(_unref(imgSmartwatch))))
          }, null, 8, _hoisted_6)
        ])
      ]),
      _createElementVNode("section", null, [
        _createElementVNode("article", _hoisted_7, [
          _createElementVNode("img", {
            src: _unref(imgGuessGame),
            alt: "screenshot",
            class: "thumbnail",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (openModal(_unref(imgGuessGame))))
          }, null, 8, _hoisted_8),
          _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "title" }, "Gamification met je hartslag", -1))
        ])
      ]),
      (modalImage.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal",
            onClick: closeModal
          }, [
            _createElementVNode("img", {
              src: modalImage.value,
              alt: "modal screenshot",
              class: "modal-content"
            }, null, 8, _hoisted_9)
          ]))
        : _createCommentVNode("", true),
      _cache[8] || (_cache[8] = _createStaticVNode("<hr data-v-42d142f2><section data-v-42d142f2><h2 class=\"title\" data-v-42d142f2>Aan de slag in 3 stappen...</h2><article data-v-42d142f2><ol class=\"instructions\" data-v-42d142f2><li data-v-42d142f2><h3 data-v-42d142f2>App downloaden</h3><p data-v-42d142f2> Download de app via de <a class=\"p-link\" href=\"#\" data-v-42d142f2>Play Store</a> of de <a class=\"p-link\" href=\"#\" data-v-42d142f2>App Store</a>. Installeer de app op je smartphone en geef toestemming voor het gebruik van sensoren (zoals hartslagmeting, indien beschikbaar). </p></li><li data-v-42d142f2><h3 data-v-42d142f2>Check de evenementenagenda</h3><p data-v-42d142f2> Bekijk in de app of op de <a class=\"p-link\" href=\"#\" data-v-42d142f2>evenementenpagina</a> wanneer en waar wij aanwezig zijn. Tijdens sommige evenementen kun je samen met anderen de spellen spelen en je hartslagervaring delen. </p></li><li data-v-42d142f2><h3 data-v-42d142f2>Speel de spellen</h3><p data-v-42d142f2> In de app vind je drie interactieve spellen waarin je je hartslag op een unieke manier ervaart. Kies zelf welk spel je wilt spelen: </p><ul class=\"games\" data-v-42d142f2><li data-v-42d142f2><strong data-v-42d142f2>Groepsspel:</strong><br data-v-42d142f2>Maak een lobby aan en nodig anderen uit om samen te spelen. Het doel is om als groep gezamenlijk een specifieke doelhartslag te bereiken. Door rustiger of actiever te worden beïnvloed je je eigen hartslag en help je het team om het gezamenlijke doel te halen. </li><li data-v-42d142f2><strong data-v-42d142f2>Ervaar je hartslag:</strong><br data-v-42d142f2>In dit spel hoor je een muziekfragment dat past bij je hartslag op dat moment. Zo merk je meteen hoe je lichaam reageert, bijvoorbeeld na beweging of rust. </li><li data-v-42d142f2><strong data-v-42d142f2>Raad je hartslag:</strong><br data-v-42d142f2>In dit spel probeer je te raden wat je hartslag nu is. Daarna zie je het echte aantal en leer je beter naar je hart te luisteren. </li></ul><p data-v-42d142f2> Tip: Speel de spellen meerdere keren op verschillende momenten van de dag of na verschillende activiteiten, en ervaar het verschil! </p></li></ol></article></section>", 2))
    ])
  ]))
}
}

})